import React from 'react';
// import RecentPatients from '../../containers/PatientSearchContainer/RecentPatients';
import RecentPatientsV2 from '../../containers/PatientSearchContainer/RecentPatientsV2';

const RecentPatientPage = () => (
    <RecentPatientsV2 />
);

export default RecentPatientPage;
